import { render, staticRenderFns } from "./order_settlement_detail.vue?vue&type=template&id=a0c3e444&scoped=true"
import script from "./order_settlement_detail.vue?vue&type=script&lang=js"
export * from "./order_settlement_detail.vue?vue&type=script&lang=js"
import style0 from "./order_settlement_detail.vue?vue&type=style&index=0&id=a0c3e444&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c3e444",
  null
  
)

export default component.exports